import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Close = styled.span`
  cursor: pointer;
  display: inline-flex;

  ${({ theme }) => css`
    border-radius: ${theme.radii[3]}px;
    padding: ${theme.space[3]}px;

    &:focus-visible {
      box-shadow: 0 0 0 3px ${theme.colors.primary.light};
      outline: none;
    }
  `};
`;
